import React from 'react';
import Modal from '@/components/Modal';
import Button from '@/components/Button';
import { scheduledPaymentModal, rejectPaymentModal } from '@/utils/translations';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  headerText: string;
  bodyText: string;
  isSubmitting?: boolean;
  error?: string | null;
}

/**
 * Shared "Are you sure you want to delete this?" confirmation, used by both ScheduledPaymentModal
 * (individual payments) and BatchOverviewModal (batches) - see confirmDelete in
 * useScheduledPaymentAction. Title/body are passed in since the two callers' copy differs (a
 * batch's body also names the batch and warns account admins get notified).
 */
const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  headerText,
  bodyText,
  isSubmitting = false,
  error
}) => (
  <Modal isOpen={isOpen} onClose={onClose} headerText={headerText} headerVariant="xxl-medium">
    <div className="flex flex-col gap-y-6 py-4">
      <p className="whitespace-pre-line text-sm font-medium text-emerge-navy">{bodyText}</p>

      {error && (
        <p role="alert" className="text-xs font-medium text-error-darkred">
          {error}
        </p>
      )}

      <div className="flex items-center justify-center gap-x-5">
        <Button size="pill" className="w-[140px]" disabled={isSubmitting} onClick={onConfirm}>
          {isSubmitting
            ? scheduledPaymentModal.deletingButton
            : scheduledPaymentModal.confirmDeleteButton}
        </Button>
        <Button
          variant="primary_inverted"
          size="pill"
          className="w-[140px] border-aux-gray"
          disabled={isSubmitting}
          onClick={onClose}>
          {rejectPaymentModal.cancelButton}
        </Button>
      </div>
    </div>
  </Modal>
);

export default DeleteConfirmModal;
